import React, { Component } from 'react';
import HorizontalRule from 'components/HorizontalRule';
import ActionBar from '../../ActionBar';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { isEmpty, startsWith } from 'lodash';
import {
  changeLocationField,
  onAddNewReportToContact,
  onChangeReportFromContact,
  removeReportFromContact,
  suppliesFieldChange,
} from 'redux/ducks/Post/Locations/actions';
import { saveAsDraft } from 'redux/ducks/Post/actions';
import { deleteAttachedShiftDocument } from 'redux/ducks/Post/Locations/actions';
import { detailsValid, trackMixpanelPageView } from 'helpers/post';
import { AddButton } from 'components/V2/Buttons';
import ConfirmationModal from 'components/V2/ConfirmationModal';
import { get } from 'lodash';
import ReportToContactList from '../../ReportToContactList';
import { Card, CardBody, CardHeader, Collapse } from 'reactstrap';
import classNames from 'classnames';
import { validateForm } from "redux/ducks/Post";
import { trackProspectUser } from "redux/ducks/User";
import isEmail from "validator/lib/isEmail";

const domain = process.env.REACT_APP_DOMAIN;

const DETAILS_FIELDS = [
  'jobExpectations',
  'scheduleDetails',
  'dressCode',
  'meals',
  'parking',
  'checkInLocation',
  'reportTo',
  'setupLocation',
  'facilityInformation',
  'restrooms',
  'ambulanceAccessPoint',
  'weatherPlans',
  'otherDetails',
];

class Details extends Component {
  constructor(props) {
    super(props);
    props.initialize('Details');
    this.state = { isModalOpen: false, additionalDetails: false };
  }

  toggle = () => this.setState({ isModalOpen: !this.state.isModalOpen });

  componentDidMount() {
    if (!this.props.editMode)
      trackMixpanelPageView('create-event/details/details', this.props.user);
  }

  onFieldChange = (ev: SyntheticInputEvent<HTMLInputElement>) => {
    const { locationIdx } = this.props;
    const { value, type, checked, name } = ev.target;
    const myValue = type === 'checkbox' ? checked : value;
    this.props.onSuppliesChange(locationIdx, name, myValue);
  };

  onAddDocument = (event: SyntheticInputEvent<HTMLInputElement>) => {
    const target = event.target;

    if (target.files && target.files.length > 0) {
      const file = target.files[0];

      const { documents } = this.props.shiftLocation;
      const names = documents.map(f => f.name);

      let newName = file.name;
      let i = 1;

      while (names.includes(newName)) {
        const dot = file.name.lastIndexOf(".");
        const base = file.name.slice(0, dot);
        const ext = file.name.slice(dot);
        newName = `${base}(${i})${ext}`;
        i++;
      }

      const newFile = new File([file], newName, { type: file.type });

      this.props.changeLocationField(
        this.props.locationIdx,
        "documents",
        [...documents, newFile]
      );

      target.value = "";
    }
  };

  onDeleteShiftDocument = (event: SyntheticInputEvent<HTMLInputElement>, document: File) => {
    event.preventDefault();
    this.props.changeLocationField(
      this.props.locationIdx,
      'documents',
      this.props.shiftLocation.documents.filter((d) => d !== document)
    );
  };

  onDeleteAttachedDocument = (event: SyntheticInputEvent<HTMLInputElement>, documentId: string) => {
    event.preventDefault();
    this.props.deleteAttachedShiftDocument(documentId, this.props.locationIdx);
  };

  urlFor(previewUrl: string) {
    return startsWith(previewUrl, '/') ? domain + previewUrl : previewUrl;
  }

  onSaveModal = () => {
    this.toggle();
    this.onSaveAndContinue();
  };

  pageIsValid = () => {
    return detailsValid(this.props.shiftLocation);
  };

  trackProspectUsers = (location) => {
    const contacts = location.reportToContacts.filter(({ email }) => isEmail(email));
    contacts.forEach(this.props.trackProspectUser);
  };

  onSaveAndContinue = () => {
    const { baseUrl, authenticated, post } = this.props;

    if (!this.pageIsValid()) {
      this.props.validateForm();
      return;
    }

    if (!this.props.authenticated) this.trackProspectUsers(this.props.shiftLocation);

    if (this.displayConfirmationModal()) {
      this.toggle();
      return;
    }

    const callback = () => {
      this.props.history.push(`${baseUrl}/details/credentials`);
    };

    if (!authenticated) {
      callback();
      return;
    }

    this.props.saveAsDraft(post, callback);
  };

  renderItem = ({ field, label, placeHolder, index }) => {
    const { shiftLocation } = this.props;

    return (
      <div className="pb-2">
        <label htmlFor={field} className="job-details-section-title gotham-medium-font">
          {label}
        </label>
        <textarea
          className="form-control nimbus-regular-font"
          style={{ width: '100%', minHeight: '60px' }}
          type="textarea"
          name={field}
          id={field}
          value={get(shiftLocation, `supplies.${field}`, '') || ''}
          rows={2}
          placeholder={placeHolder}
          onChange={this.onFieldChange}
        />
      </div>
    );
  };

  displayConfirmationModal = () => {
    const { shiftLocation } = this.props;
    return (
      shiftLocation.documents.length + shiftLocation.existingDocuments.length === 0 &&
      DETAILS_FIELDS.every((field) => isEmpty(get(shiftLocation, `supplies.${field}`, ''))) &&
      !this.state.isModalOpen
    );
  };

  render() {
    const { shiftLocation, wasValidated, missingContacts, contactErrors } = this.props;
    const { reportToContacts } = shiftLocation;
    const { additionalDetails } = this.state;

    const onAddNewReportToContact = this.props.onAddNewReportToContact(shiftLocation.idx);
    const onRemoveReportFromContact = this.props.onRemoveReportFromContact(shiftLocation.idx);
    const onChangeReportFromContact = this.props.onChangeReportFromContact(shiftLocation.idx);
    return (
      <div className="v2details">
        <main>
          <header>
            <div className="screen-title">Details</div>
          </header>
          <div className="details-container">
            <React.Fragment>
              <div>
                <label className="job-contact-copy nimbus-regular-font">
                  <span className="gotham-medium-font">
                    Who should the athletic trainer report to?{' '}
                  </span>
                  <div className="nimbus-regular-font">
                    Contact info is only visible to athletic trainers once they confirm a job.
                  </div>
                </label>
              </div>
              <ReportToContactList
                contacts={reportToContacts || []}
                removeContact={onRemoveReportFromContact}
                changeContact={onChangeReportFromContact}
                {...this.state}
                wasValidated={wasValidated}
                errors={contactErrors}
                emptyError={missingContacts}
              />
              <div className="d-flex button-row">
                <button className="report-contact-btn" onClick={onAddNewReportToContact}>
                  ADD CONTACT
                </button>
              </div>
            </React.Fragment>

            <HorizontalRule dashed margin="1rem" />

            {this.renderItem({
              field: 'jobExpectations',
              label: 'Job Responsibilities',
              placeHolder: 'What are the job expectations?',
            })}

            <HorizontalRule dashed margin="1rem" />

            {this.renderItem({
              field: 'checkInLocation',
              label: 'Check-In Location',
              placeHolder: 'Where should the AT check in upon arrival?',
            })}

            <HorizontalRule dashed margin="1rem" />

            <div className="shift-documents">
              <p className="job-details-section-title gotham-medium-font">
                Shift Documents
              </p>
              <div className="shift-copy nimbus-regular-font">
                Use this for Onboarding Forms, policies, etc. Uploaded documents are emailed
                to ATs before the shift.
              </div>
              <div className="form-group">
                <AddButton
                  className="upload-documents-btn"
                  onClick={(e) => document.getElementById('upload-shifts-doc').click()}
                >
                  Upload Documents
                </AddButton>
                <input
                  className="custom-file-input"
                  type="file"
                  name="upload-shifts-doc"
                  accept="*"
                  id="upload-shifts-doc"
                  hidden
                  onChange={this.onAddDocument}
                />
              </div>
              <HorizontalRule dashed margin="1rem" />
            </div>

            <div className="col-md-9 col-sm-6 shift-documents-display">
              {!isEmpty(shiftLocation) &&
                Array.isArray(shiftLocation.existingDocuments) && (
                  <React.Fragment>
                    {shiftLocation.existingDocuments.map((document) => (
                      <div className="py-2 doc-upload-list" key={document.id}>
                        <i className="fas fa-file-alt px-2"></i>
                        <a
                          className="px-2 nimbus-regular-font"
                          target="_blank"
                          rel="noopener noreferrer"
                          href={this.urlFor(document.url)}
                        >
                          {document.filename}
                        </a>
                        <i
                          className="material-icons remove-contact-btn"
                          onClick={(e) => this.onDeleteAttachedDocument(e, document.id)}
                        >
                          close
                        </i>
                      </div>
                    ))}
                  </React.Fragment>
                )}
              {Array.isArray(shiftLocation.documents) && (
                <React.Fragment>
                  {shiftLocation.documents.map((document, i) => (
                    <div className="py-2 doc-upload-list" key={i}>
                      <i className="fas fa-file-alt px-2"></i>
                      <span className="px-2 nimbus-regular-font">{document.name}</span>
                      <i
                        className="material-icons remove-contact-btn"
                        onClick={(e) => this.onDeleteShiftDocument(e, document)}
                      >
                        close
                      </i>
                    </div>
                  ))}
                </React.Fragment>
              )}
            </div>

            <Card>
              <CardHeader onClick={() => this.setState({ additionalDetails: !additionalDetails })}>
                <i
                  className={classNames('fa arrow', {
                    'fa-caret-down': additionalDetails,
                    'fa-caret-right': !additionalDetails,
                    'add-color': additionalDetails,
                  })}
                ></i>
                <div className="additional-details-title nimbus-regular-font">
                  Additional Details
                </div>
              </CardHeader>
              <Collapse isOpen={additionalDetails}>
                <CardBody>
                  <div>
                    {this.renderItem({
                      field: 'dressCode',
                      label: 'Dress Code',
                      placeHolder: 'Does the AT need to wear something specific?',
                    })}

                    <HorizontalRule dashed margin="1rem" />

                    {this.renderItem({
                      field: 'meals',
                      label: 'Meals provided',
                      placeHolder: 'Are any meals provided?',
                    })}

                    <HorizontalRule dashed margin="1rem" />

                    {this.renderItem({
                      field: 'parking',
                      label: 'Parking',
                      placeHolder: 'Where should the AT park?',
                    })}

                    <HorizontalRule dashed margin="1rem" />

                    {this.renderItem({
                      field: 'reportTo',
                      label: 'Report To',
                      placeHolder: 'Who should the AT check-in with upon arrival?',
                    })}

                    <HorizontalRule dashed margin="1rem" />

                    {this.renderItem({
                      field: 'setupLocation',
                      label: 'Set-Up Location',
                      placeHolder: 'Where should the AT set up for the shift?',
                    })}

                    <HorizontalRule dashed margin="1rem" />

                    {this.renderItem({
                      field: 'restrooms',
                      label: 'Restrooms',
                      placeHolder: 'Where are the restrooms located?',
                    })}

                    <HorizontalRule dashed margin="1rem" />

                    {this.renderItem({
                      field: 'ambulanceAccessPoint',
                      label: 'Ambulance Access Point',
                      placeHolder: 'Where should ambulances be directed?',
                    })}

                    <HorizontalRule dashed margin="1rem" />

                    {this.renderItem({
                      field: 'weatherPlans',
                      label: 'Weather Plans/Shelters',
                      placeHolder: 'Alert systems and location of shelter',
                    })}

                    <HorizontalRule dashed margin="1rem" />

                    {this.renderItem({
                      field: 'otherDetails',
                      label: 'Other',
                      placeHolder: 'Are there any other details the AT should know about the job?',
                    })}

                    <HorizontalRule dashed margin="1rem" />
                  </div>
                </CardBody>
              </Collapse>
            </Card>
          </div>
          <ActionBar
            editMode={this.props.editMode}
            backTo={`${this.props.baseUrl}/details/supplies`}
            currentStep="details/details"
            onSaveAndContinue={this.onSaveAndContinue}
            nextDisabled={() => !this.pageIsValid()}
          />
        </main>
        <ConfirmationModal
          isOpen={this.state.isModalOpen}
          toggle={this.toggle}
          title="No Details Added"
          body="Please confirm there are no details or documents to add for this location."
          onSave={this.onSaveModal}
          cancelText="Go Back"
          onCancel={this.toggle}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { post } = state;
  const { locationIdx } = post.navigation;
  const shiftLocation = post.locations[locationIdx];
  const { wasValidated } = post.validations.details;
  const contactErrors =
    get(shiftLocation, `contactErrorMessages.reportToContacts`, new Array(shiftLocation.reportToContacts.length).fill({}));
  const missingContacts = get(shiftLocation, `contactErrorMessages.emptyReportToContacts`)

  return {
    post,
    shiftLocation,
    locationIdx,
    authenticated: state.session.authenticated,
    user: state.session.currentUser,
    wasValidated: wasValidated || ownProps.editMode,
    contactErrors,
    missingContacts,
  };
};

const mapDispatchToProps = (dispatch) => ({
  saveAsDraft: (post, callback) => dispatch(saveAsDraft({ post, callback, from: 'details' })),
  onSuppliesChange: (locationIndex, name, value) =>
    dispatch(suppliesFieldChange({ locationIndex, name, value })),
  changeLocationField: (idx, name, value) => dispatch(changeLocationField({ name, value, idx })),
  deleteAttachedShiftDocument: (documentId, locationId) =>
    dispatch(deleteAttachedShiftDocument({ documentId, locationId })),
  onAddNewReportToContact: (locationIndex) => () =>
    dispatch(onAddNewReportToContact({ locationIndex })),
  onRemoveReportFromContact: (locationIndex) => (contactIndex) =>
    dispatch(removeReportFromContact({ locationIndex, contactIndex })),
  onChangeReportFromContact: (locationIndex) => (idx, contact) =>
    dispatch(onChangeReportFromContact({ locationIndex, idx, contact })),
  validateForm: () => dispatch(validateForm("details")),
  trackProspectUser: (contact) =>
    dispatch(trackProspectUser({ contact, event_name: 'job_contact_added' })),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Details));
